export enum SignerType {
  BUYER = 'buyer',
  SELLER = 'seller',
}

export enum SigningStatus {
  PENDING = 'pending',
  SIGNED = 'signed',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
}

export interface IContractSigner {
  signer_type: SignerType;
  signer_name: string;
  signer_email: string;
  signing_status: SigningStatus;
  signed_at?: string;
}
